export default __webpack_public_path__ + "static/comparisons-breadth-features-6a1a411e18aee3f9036916a48e348589.png";